import { theme } from '@theme';
import { FC, useState } from 'react';
import styled from 'styled-components';
import transunionImg from '../../../../assets/svgs/logo-transunion-white.svg';
import { Contract } from '../../../../types/header/Contract';

type ReactivateDealModalHeaderProps = {
  contract: Contract;
  onCloseClick: () => void;
};

const ReactivateDealModalHeader: FC<ReactivateDealModalHeaderProps> = ({
  contract,
  onCloseClick,
}) => {
  const [hovered, setHovered] = useState<boolean>(false);
  const toggleHover = () => setHovered(!hovered);

  return (
    <Wrapper>
      <h4 className='modal-title'>
        {contract?.transUnionConfirmationNeeded && (
          <div className='stamp-transunion'>
            <img src={transunionImg} />
          </div>
        )}
        <strong>{`${contract?.dealType} Contract for ${contract?.buyerFullName}`}</strong>
      </h4>
      <div className='header-actions'>
        <button
          data-testid='reactivate-modal-header-close-button'
          className={hovered ? 'close hovered' : 'close'}
          onClick={onCloseClick}
          type='button'
          onMouseEnter={toggleHover}
          onMouseLeave={toggleHover}
        >
          Close
        </button>
      </div>
    </Wrapper>
  );
};

export default ReactivateDealModalHeader;

const Wrapper = styled.div`
  background-color: ${theme.palette.text.purple};
  position: relative;
  height: 50px;
  padding: 0 0 0 20px;
  border-radius: 6px 6px 0 0;
  border: 0;

  .modal-title {
    color: white;
    line-height: 50px;
    padding-right: 89px;
    font-size: ${theme.typography.h4}px;

    strong {
      text-transform: uppercase;
    }
  }

  .header-actions {
    position: absolute;
    bottom: 0;
    right: 0;
    height: 100%;

    .close {
      font-size: ${theme.typography.h5}px;
      color: white;
      border: 0;
      text-shadow: none;
      height: 100%;
      position: relative;
      bottom: 0;
      right: 0;
      margin-top: 0;
      padding: 0 20px;
      cursor: pointer;
      border-left: 1px solid ${theme.palette.sidebarGradient.from};
      border-top: none;
      border-bottom: none;
      border-right: none;
      opacity: 1;
      text-transform: uppercase;
      background: transparent;
      &.hovered {
        background: ${theme.palette.hightLightPurple};
      }
    }
  }
`;
